export class TemaCard {
  constructor(
    public id: string,
    public topic: string,
    public type: 'word' | 'phrase' | 'idiom' | 'conjunction' | 'sentence' | 'number',
    public spanish: string,
    public english: string,
    public notes?: string,
    public related?: { spanish: string; english: string }[],
    public example?: string,
  ) { }
}
